module.exports = __webpack_public_path__ + "static/media/blackbelts3.2db71995.jpg";